module.exports = __webpack_public_path__ + "static/porqueimg3-24c0549f19d0bbb77dc634223bfd44cb.jpg";